import { render } from "./EdTech.vue?vue&type=template&id=20352ff5"
const script = {}

import exportComponent from "C:\\Users\\55132870\\Desktop\\GitHub\\leed-summer-conference-23\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__